import React from 'react'
import {ErrorBoundaryComponent} from "../../components/other/ErrorBoundry/ErrorBoundaryComponent";

const NotFound:React.FC = () => (
  <ErrorBoundaryComponent type={'404'} />
)

export default NotFound
